module.exports = __webpack_public_path__ + "static/media/KenoMini-Icon.be207960.png";